// extracted by mini-css-extract-plugin
export default {"textBox":"styles_textBox__22w2z","text":"styles_text__8Crni","close":"styles_close__cq5CP","error":"styles_error__Shh-Q","editMode":"styles_editMode__ZKECf"};